<template>
  <div class="evaluate-con">
    <div class="score">
      <div class="title" v-if="!orderCon.isPost">请您对本次服务进行评分</div>
      <div class="title" v-else>感谢您对本次服务进行评分</div>
      <div class="item acea-row row-middle">
        <div class="starsList">
          <span
            @click="stars(indexn)"
            v-for="(itemn, indexn) in scoreList.stars"
            :key="indexn"
            class="iconfont"
            :class="
              scoreList.index >= indexn
                ? 'icon-shitixing font-color-yellow'
                : 'icon-kongxinxing'
            "
          ></span>
        </div>
        <div class="evaluate">{{scoreList.stars[scoreList.index]||''}}</div>
      </div>

      <div class="question" v-if="scoreList.index < 4">
        <div class="content">存在以下哪些问题？</div>
        <div class="evaluateOptions">
          <span v-for="(o,i) in selectOps" :key="i" class="options" :class="o.isSelect ? 'active':''" @click="selectO(i)">{{o.name}}</span>
        </div>
      </div>
      <div class="textarea">
        <textarea
          placeholder="欢迎给我们的服务提建议～"
          v-model="orderCon.comment"
        ></textarea>
      </div>
      <div class="evaluateBnt bg-color-red" @click="submit" v-if="!orderCon.isPost">立即评价</div>
    </div>
  </div>
</template>

<script>
import { getServEvaluate, saveServEvaluate } from "@api/store";
import { trim, VUE_APP_API_URL } from "@utils";
import { required } from "@utils/validate";
import VueCoreImageUpload from "vue-core-image-upload";
import { validatorDefaultCatch } from "@utils/dialog";

const NAME = "GoodsEvaluate";

export default {
  name: NAME,
  components: {
    VueCoreImageUpload
  },
  props: {},
  data: function() {
    return {
      orderCon: {
        comment: '',
        options: [],
        product_score : -1,
        isPost: false,
      },
      selectOps: [
        {'name':'服务态度差', 'isSelect':false},
        {'name':'回答不准确', 'isSelect':false},
        {'name':'没解决问题', 'isSelect':false},
        {'name':'不礼貌', 'isSelect':false},
        {'name':'说脏话', 'isSelect':false},
        {'name':'其他', 'isSelect':false},
      ],
      scoreList: {
        stars: ["极差，急需改善", "不满意，期待改善", "基本满意，还需改善", "比较满意", "非常满意"],
        index: -1
      },
      unique: this.$route.params.id
    };
  },
  mounted: function() {
    this.getOrderProduct();
  },
  watch: {
    $route(n) {
      if (n.name === NAME && this.unique !== n.params.id) {
        this.unique = n.params.id;
        this.$set(this.scoreList, "index", -1);
        this.orderCon.comment = "";
        this.getOrderProduct();
      }
    }
  },
  methods: {
    getOrderProduct: function() {
      let that = this,
        unique = that.unique;
      getServEvaluate(unique).then(res => {
        that.orderCon = res.data;
        console.log(res.data)
        if (res.data.isPost) {
          that.selectOps = res.data.options
          that.scoreList.index = res.data.product_score - 1
        }
      });
    },
    selectO: function(index) {
      if (this.orderCon.isPost) return;
      this.selectOps[index].isSelect = !this.selectOps[index].isSelect;
    },
    stars: function(indexn) {
      if (this.orderCon.isPost) return;
      this.scoreList.index = indexn;
    },
    async submit() {
      const expect = trim(this.orderCon.comment),
      product_score = this.scoreList.index + 1 === 0 ? "" : this.scoreList.index + 1,
      options = this.selectOps,
      id = this.unique;
      try {
        await this.$validator({
          product_score: [
            required("请选择分数", {
              type: "number"
            })
          ],
        }).validate({ product_score });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      saveServEvaluate({
        id:id,
        product_score: product_score,
        options: options,
        comment: expect
      })
        .then(() => {
          this.$dialog.success("评价成功");
          this.getOrderProduct();
        })
        .catch(res => {
          this.$dialog.error(res.msg);
        });
    }
  }
};
</script>
<style scoped>
.evaluate-con .score .item .starsList .iconfont.font-color-yellow {
  color:#F5A623;
}
.evaluate-con .score .item .starsList,.evaluate-con .score .item .evaluate{
  width:100%;
  margin-bottom: 0.36rem;
}
.evaluate-con .score .item .evaluate {
  color: #F5A623;
  font-size: 0.28rem;
}
.evaluate-con .score .textarea .list .pictrue.uploadBnt {
  border: 1px solid #ddd;
}
.evaluate-con .score {
  text-align: center;
  padding-top: 1rem;
}
.evaluate-con .score .title {
  color: #1A1A1A;
  font-size: 0.32rem;
  font-weight: 500;
  margin-bottom: 0.5rem;
}
.evaluate-con .score .item .starsList .iconfont {
  font-size: 0.6rem;
}
.evaluate-con .score .question {
  text-align: center;
}
.evaluate-con .score .question .content
{
  color: #1A1A1A;
  font-weight: 500;
  font-size: 0.28rem;
  margin-bottom: 0.4rem;
  margin-top: 0.44rem;
}
.evaluate-con .score .question .evaluateOptions {
  display: flex;
  flex-flow:wrap;
  justify-content: space-around;
}
.evaluate-con .score .question .evaluateOptions .options {
  width: 40%;
  border: 1px solid #C8C8C8;
  text-align: center;
  margin: 0.15rem 0;
  padding: 0.13rem 0;
  color: #888888;
}
.evaluate-con .score .question .evaluateOptions .options.active
{
  border: 1px solid #e93323;
  color: #e93323;
}
</style>
